import logo from './logo.svg';
import './App.css';
import { BrowserRouter, HashRouter , Routes, Route } from 'react-router-dom';
import Home from './screens/Home';

import Login from './screens/Login';

import { useEffect } from 'react';

import  About from './screens/About';







function App() {
  


  return (

   <BrowserRouter>

        <Routes>
      <Route path='/about' element={<About />} />
      <Route path="/" element={<Home />} />
   
      <Route path="/login" element={<Login />} />


    </Routes>

   </BrowserRouter>

  );
}







export default App;
